<div class="td-card td-score-development-card">
  <div class="td-card-header">
    <span class="td-card-title">{{ titleKey | translate }}</span>
    <div class="td-chips" *ngIf="showChips">
      <button type="button" class="td-chip"
              *ngFor="let view of chipViews; trackBy: trackByUuid"
              [ngClass]="{'active': view.active}"
              [ngStyle]="view.buttonStyle"
              [pTooltip]="view.chip.title" tooltipPosition="bottom" tooltipStyleClass="tooltip-style"
              (click)="selectChip(view.chip)">
        <span class="td-chip-icon" [ngStyle]="view.iconStyle"></span>
      </button>
    </div>
  </div>
  <span class="td-card-subtitle">
    {{ 'td_score_development_subtitle' | translate : {name: activeChipTitle} }}
  </span>
  <div class="spinner-border text-primary td-chart-spinner" role="status" *ngIf="loading"></div>
  <ng-container *ngIf="!loading && hasData">
    <div *ngIf="showChart" echarts [options]="chartOption" [merge]="chartOption" class="td-chart"></div>
    <div *ngIf="!showChart" echarts [options]="chartOption" [merge]="chartOption" class="td-chart"></div>
  </ng-container>
  <span class="td-chart-empty" *ngIf="!loading && !hasData">{{ 'td_no_data' | translate }}</span>
</div>
